module.exports = __webpack_public_path__ + "static/img/avtor.e63bc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avtor.png
// module id = uNTu
// module chunks = 55